
export const VERSION = '5.8.10'; // Update this manually on each release


